interface IsRedoBlockedParams {
  blockRedo: boolean
  levelFinished: boolean
  allChallengesFinished: boolean
}

/**
 * Mirrors the API rule in ProgressService::ChallengeFinisher#ensure_redo_allowed!,
 * which rejects a finish with `challenge_done` (HTTP 422) when the journey blocks
 * redo and both the challenge and its level are already finished.
 *
 * The server checks a single challenge, so a challenge added to an already
 * finished level stays playable — hence `allChallengesFinished` rather than
 * `levelFinished` alone.
 *
 * Takes primitives rather than a LevelProgress so callers that cannot wait for
 * the journeys store (deep links into a level) can feed it from the level
 * record plus UserProgress.
 */
export function isRedoBlocked({
  blockRedo,
  levelFinished,
  allChallengesFinished
}: IsRedoBlockedParams): boolean {
  return blockRedo && levelFinished && allChallengesFinished
}
